import React from 'react'
import PropTypes from 'prop-types'
import {ButtonGroup} from 'reactstrap'
import {ReactComponent as IconFailedDesign} from "../../../../assets/icon/icon-failedDesign.svg"
import TagRequestUpdate from "../../SingleAction/TagRequestUpdate"
import {getLocalData} from "../../../../services/StorageServices"
import {parseJwt} from "../../../../share/parseToken"
import { Tooltip } from 'antd'

class ChildrenActionCol extends React.PureComponent {
    render() {
        const {production_status, handleClickEditProduct, handleClickMarkFaileDesign, productStatus, tags, itemsRequest, item, onChangeFilterTag} = this.props
        const barcodeNumber = `#${item.barcodeNumber}_${item.pos}`
        const itemRequest = itemsRequest.filter(item => item.fac_barcode_number === barcodeNumber)
        const listProductStatusRequestUpdate = ['false_design', 'in_production', 'pending', 'on-hold']
        const token = getLocalData('accessToken')
        const user = token !== '' &&  parseJwt(token).permissions ? parseJwt(token).permissions : {}

        return (
            <div className={productStatus === 'cancelled' ? 'notDisableCancel Action' : 'Action'}>
                <ButtonGroup>
                    {
                        production_status !== 'labelled' && (
                            <Tooltip title="Edit Item">
                                <i className='icon-pencil5 text-warning mr-3 cursor-pointer' onClick={handleClickEditProduct}/>
                            </Tooltip>
                        )
                    }

                    {
                        (listProductStatusRequestUpdate.includes(production_status) && user.hasOwnProperty('request_update')) &&
                        <Tooltip title="Update Design">
                            <IconFailedDesign
                                className="cursor-pointer"
                                width={20}
                                height={15}
                                onClick={handleClickMarkFaileDesign}
                            />
                        </Tooltip>
                    }
                </ButtonGroup>

                {
                    !!tags && tags.length > 0 &&
                    <div className="TagRequest mt-2">
                        {
                            tags.map((tag, index) => {
                                const itemRequestCurrent = itemRequest[index] || {}
                                return <TagRequestUpdate tag={tag} item={item} key={index} itemRequest={itemRequestCurrent.content || ''} onChangeFilterTag={onChangeFilterTag}/>
                            })
                        }
                    </div>
                }
            </div>
        )
    }
}

ChildrenActionCol.propTypes = {
    productStatus: PropTypes.string.isRequired,
    production_status: PropTypes.string.isRequired,
    handleClickEditProduct: PropTypes.func.isRequired,
}

export default ChildrenActionCol
